import React from 'react';
/* eslint-disable space-infix-ops */
export const LoginIdContext = React.createContext(null);
/* eslint-enable space-infix-ops */
